const sendToNative = (action: string, value: string) => {
  try {
    //@ts-ignore
    toApp.postMessage(
      JSON.stringify({
        action,
        value,
      }),
    );
  } catch (e) {
    console.log("toApp is undefined");
    console.log("action : ", action);
    console.log("value : ", value);
  }
};

export const vibrate = (sec = 1) => {
  sendToNative("vibrate", String(sec));
};
